import React, { useMemo } from "react";
import { parseSync } from "subtitle";
import Captions from "./util/util_caption";
import './VTTReader.scss'

export default function VTTReader({ raw, progress, duration}) {
    const parsed = parseSync(raw);
    return <Captions captions={parsed} progress={progress} duration={duration} />;
} 